import { CHAT_MESSAGE_TAG } from '@cp/src/pages/WhatsappChatbot/types';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import CountTag from './CountTag';
import { useEffect, useState } from 'react';
import useIsTabActive from '@cp/src/utils/TabActiveCheck';

const NotificationsCount = () => {
  const chatBuckets = useSelector((state: RootState) => state.whatsappChatbot.chatBuckets);
  const isTabActive = useIsTabActive();
  const [count, setCount] = useState(0);

  const whatsAppChatCount = () => {
    let chatCount = 0;
    for (const key in chatBuckets) {
      if (
        key === CHAT_MESSAGE_TAG.NEWLY_ASSIGNED ||
        key === CHAT_MESSAGE_TAG.MESSAGE_RECEIVED_UN_READ
      ) {
        chatCount += Object.keys(chatBuckets[key]).length;
      }
    }
    setCount(chatCount);
    return count;
  };
  useEffect(() => {
    if (isTabActive) {
      whatsAppChatCount();
    }
  }, [isTabActive, chatBuckets]);
  return (
    <div className="absolute">
      <CountTag unreadNotificationCount={count} />
    </div>
  );
};

export default NotificationsCount;
